


























import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action, Mutation, State } from 'vuex-class';
import { DatabaseModuleState } from '../store/modules/database/types';
import SidebarDatabases from '../components/SidebarDatabases.vue';
import SidebarTables from '../components/SidebarTables.vue';

const namespace: string = 'database';

@Component({
  components: {
    SidebarDatabases,
    SidebarTables,
  },
})
export default class Sidebar extends Vue {
  @Getter private currentDb!: string;
  @Getter private currentTable!: string;
  @Getter private filteredTables!: string[];
  @Getter private filterText!: string;
  @Getter private tableListLoading!: boolean;
  @Action private getCurrentDb: any;
  @Action private getDbTables: any;
  @Action private getCurrentTable: any;
  @Mutation private filterTextChange: any;
  @Mutation private initialState: any;
  @State(namespace) private database!: DatabaseModuleState;
  @Action('removeDbFromStorage', { namespace })
  private removeDbFromStorage: any;
  @Action('getDbList', { namespace }) private getDbList: any;
  @Action('loadProfiles', { namespace }) private loadProfiles!: () => Promise<void>;
  @Mutation('toggleEditModal', { namespace }) private toggleEditModal: any;
  @Mutation('toggleCreateModal', { namespace: 'table' })
  private toggleCreateModal: any;
  @Mutation('toggleDeleteModal', { namespace: 'table' })
  private toggleDeleteModal: any;
  private get isDesktop() {
    return !!window.electronAPI;
  }

  private created() {
    this.getDbList();
    if (this.isDesktop) {
      this.loadProfiles();
    }
  }
}
